import { HtmlText } from "~/components/Base/HtmlText/HtmlText";
import PropTypes from "prop-types";

export const formItemLabelId = (oid) => `${oid}-label`;

// Composite widgets carry the item id on a div, which <label for> cannot
// target; they get a span the widget references via aria-labelledby.
export function FormItemLabel({ oid, label, targetsControl = true }) {
  return targetsControl ? (
    <HtmlText className="form-item__label" element="label" htmlFor={oid} htmlString={label} />
  ) : (
    <HtmlText
      className="form-item__label"
      element="span"
      id={formItemLabelId(oid)}
      htmlString={label}
    />
  );
}

FormItemLabel.propTypes = {
  oid: PropTypes.string,
  label: PropTypes.string,
  targetsControl: PropTypes.bool,
};
